import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from '../admin/admin.component';
import { ChapterHeadingComponent } from './chapter-heading/chapter-heading.component';
import { ChapterTopicComponent } from './chapter-topic/chapter-topic.component';
import { ChapterContentComponent } from './chapter-content/chapter-content.component';
import { TeachingComponent } from './teaching/teaching.component';
import { LearningBookTitleComponent } from './learning-book-title/learning-book-title.component';
import { TutorialComponent } from './tutorial/tutorial.component';
import { ClassBookTitleMapComponent } from './class-book-title-map/class-book-title-map.component';
import { WorkSheetComponent } from './work-sheet/work-sheet.component';
import { QuestionBankComponent } from './question-bank/question-bank.component';
import { OnlineexamComponent } from './onlineexam/onlineexam.component';
import { OnlinetutorialComponent } from './onlinetutorial/onlinetutorial.component';
import { OnlineteachingComponent } from './onlineteaching/onlineteaching.component';
import { TestReportComponent } from './test-report/test-report.component';
import { LiveClassComponent } from './live-class/live-class.component';
import { StudentTestPrintComponent } from './student-test-print/student-test-print.component';
import { StaffTestPrintComponent } from './staff-test-print/staff-test-print.component';
import { StudentTestReportPrintComponent } from './student-test-report-print/student-test-report-print.component';
import { TestReportPrintComponent } from './test-report-print/test-report-print.component';
import { LecturePlanComponent } from './lecture-plan/lecture-plan.component';
import { StudentliveclassComponent } from './studentliveclass/studentliveclass.component';




const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    children: [
       { path: 'learningbooktitle', component: LearningBookTitleComponent, pathMatch: 'full' },
       { path: 'chapterheading', component: ChapterHeadingComponent, pathMatch: 'full' },
       { path: 'chaptertopic', component: ChapterTopicComponent, pathMatch: 'full' },
       { path: 'topiccontent', component: ChapterContentComponent, pathMatch: 'full' },
       { path: 'classbooktitlemap', component: ClassBookTitleMapComponent, pathMatch: 'full' },
       { path: 'teaching', component: TeachingComponent, pathMatch: 'full' },
       { path: 'tutorial', component: TutorialComponent, pathMatch: 'full' },
       { path: 'worksheet', component: WorkSheetComponent, pathMatch: 'full' },
       { path: 'questionbank', component: QuestionBankComponent, pathMatch: 'full' },
       { path: 'onlineteaching', component: OnlineteachingComponent, pathMatch: 'full' },
       { path: 'onlinetutorial', component: OnlinetutorialComponent, pathMatch: 'full' },
       { path: 'onlineexam', component: OnlineexamComponent, pathMatch: 'full' },
       { path: 'liveclass', component: LiveClassComponent, pathMatch: 'full' },
       { path: 'lecture-plan', component: LecturePlanComponent, pathMatch: 'full' },
       { path: 'testreport', component: TestReportComponent, pathMatch: 'full' },
       { path: 'studentliveclass', component: StudentliveclassComponent, pathMatch: 'full' },

    ]
  },
  {
    path: '',
    children: [
       { path: 'studenttestprint', component: StudentTestPrintComponent, pathMatch: 'full' },
       { path: 'stafftestprint', component: StaffTestPrintComponent, pathMatch: 'full' },
       { path: 'testreportprint', component: TestReportPrintComponent, pathMatch: 'full' },
       { path: 'studenttestreportprint', component: StudentTestReportPrintComponent, pathMatch: 'full' }

    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LearningRoutingModule { }
